import { useEffect, useState } from "react";
import { Divider, Flex, Image, Text } from "@chakra-ui/react";
import { Alert, RefundModal } from "@/components";
import { getTenantConfig } from "@/config/tenantConfig";
import { WithAuth } from "@/hoc";
import {
  getColorBadgeStatus,
  getStatus,
  isChargeFullyRefunded,
  phone_format,
  formatDate,
  showToast,
} from "@/utils";
import { useAlert, useCharge } from "@/hooks";
import { WhatsappLogoIcon, EnvelopeIcon } from "@phosphor-icons/react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { InvoiceTable } from "@/layouts/ChargeHistory/InvoiceTable";
import { Chargeback, ChangeToPaid, ChangeToPaidAlertMessage, changeToPaidAlertTitle } from "@/layouts";
import { CustomModal } from "@/components/CustomModal";
import { InfoIconNotFilled } from "@/styles/icons/InfoIconNotFilled";
import { Container } from "./styles";
import { format } from "date-fns";
import { ChargeTriesProps, ErrorModal } from "@/layouts/ErrorModal";
import ChargeInstallments from "@/components/FeatureToggleComponents/charges/ChargeInstallments";
import { SplitTable } from "@/layouts/ChargeHistory/SplitTable";
import { ReceivableTable } from "@/layouts/ChargeHistory/receivablesTables";
import { useAsyncFunction } from "@/hooks/useAsyncFunction";
import { RefundPOSModal } from "./refund-pos-modal";
import { useRefundPOS } from "@/hooks/useRefundPOS";
import { useRefund } from "@/hooks/useRefundPartial";
import { usePaymentReceipt } from "@/hooks/usePaymentReceipt";
import { FiDownload } from "react-icons/fi";
import {
  Button,
  Card,
  ColumnDefinition,
  ContentRow,
  PageHeading,
  Pills,
  Section,
  Table,
  Tooltip,
} from "barte-design-system";
import { ChargesTries } from "@/models";

declare global {
  interface Window {
    cancelMailUrl?: string;
    cancelLetterUrl?: string;
  }
}

const CHARGE_STATUS = {
  PAID: "PAID",
  REFUND: "REFUND",
  SCHEDULED: "SCHEDULED",
  LATE: "LATE",
  FAILED: "FAILED",
  CANCELED: "CANCELED",
  DISPUTE: "DISPUTE",
} as const;

const PAYMENT_METHOD = {
  CREDIT_CARD: "Cartão de Crédito",
  BOLETO: "Boleto",
  PIX: "Pix",
} as const;

const CHARGE_TITLE = {
  VENDA_FISICA: "Venda Física",
} as const;

const FEATURE_TOGGLE = {
  VIEW_SELLER_REFUND: "view_seller_refund",
  VIEW_SELLER_REFUND_POS: "view_seller_refund_pos",
  VIEW_DISABLE_REFUND: "view_disable_refund",
} as const;

function CobrancaDetalhes() {
  const [fraudCheckboxState, setFraudCheckboxState] = useState<boolean>(false);
  const [chargebackModalStateInfo, setChargebackModalStateInfo] =
    useState<boolean>(false);
  const [splitData, setSplitData] = useState([]);
  const [refundData, setRefundData] = useState({} as any);
  const [chargebackModalState, setChargebackModalState] = useState(false);
  const [deleteChargeModalState, setDeleteChargeModalState] = useState(false);
  const [errorModalState, setErrorModalState] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [errorModal, setErrorModal] = useState<ChargeTriesProps>(null);
  const user = JSON.parse(localStorage.getItem("barte-user-info"));
  const { id } = useParams();
  const navigate = useNavigate();
  const { onClose, showAlert, cancelRef, setShowAlert } = useAlert();
  const viewSplit = localStorage
    .getItem("barte-features-list-user")
    .includes("view_split_subseller_payment_link");
  const featureTogglesUser = localStorage?.getItem("barte-features-list-user");

  const {
    deleteCharge,
    getChargeData,
    handleChangeToPaid,
    handleChargeBackCharge,
    getStatmentChargeById,
    charge,
    getChargeSubsellers,
    sendCancelMail,
    getCancelLetter,
  } = useCharge();
  const { getRefund } = useRefundPOS();
  const { handleDownloadReceipt } = usePaymentReceipt();
  const [statementCharge, setStatementCharge] = useState({} as any);
  const [isLoadingCancelMail, setIsLoadingCancelMail] = useState(false);
  const [isLoadingCancelLetter, setIsLoadingCancelLetter] = useState(false);
  const [reload, setReload] = useState(1);
  const [isGenerating, setIsGenerating] = useState(false);
  const [downloadingReceipt, setIsDownloadingReceipt] =
    useState<boolean>(false);

  const { verifyRefundBalance, responseVerify, solicitationRefundLetter } =
    useRefund();
  const { execute, loading } = useAsyncFunction(verifyRefundBalance);

  useEffect(() => {
    async function verifyRefund() {
      try {
        await execute(id);
      } catch (error) {
        error?.response?.data?.errors?.map((err) => {
          showToast({ type: "error", message: `${err?.code} - ${err?.description}` });
        });
      }
    }
    verifyRefund();
  }, []);

  async function handleSolicitationRefundLetter(uuid: string) {
    setIsGenerating(true);
    try {
      const response = await solicitationRefundLetter(uuid);
      window.open(response?.url, "_blank");
    } catch (error) {
      console.error("Erro ao solicitar estorno:", error);
      throw error;
    } finally {
      setIsGenerating(false);
    }
  }

  async function handleDownloadReceiptCharge(chargeId: string) {
    setIsDownloadingReceipt(true);
    try {
      await handleDownloadReceipt(chargeId);
    } catch (error) {
      return error;
    } finally {
      setIsDownloadingReceipt(false);
    }
  }

  async function getSplitData() {
    try {
      const response = await getChargeSubsellers(id);
      setSplitData(response?.data);
    } catch (error) {
      error?.response?.data?.errors.map((err) => {
        showToast({ type: "error", message: `${err?.code} - ${err?.description}` });
      });
    }
  }

  async function getStatementCharge(chargeId: string) {
    try {
      const receivables = await getStatmentChargeById(chargeId);
      setStatementCharge(receivables);
    } catch (error) {
      showToast({
        type: "error",
        message: "Falha ao carregar as informações dos recebiveis.",
      });
    }
  }

  async function getRefundPOSData() {
    try {
      const response = await getRefund(id);
      setRefundData(response.data);
    } catch (error) {
      setRefundData({});
    }
  }

  useEffect(() => {
    if (!id) return;
    getChargeData(String(id));
    if (user?.roles?.includes("SELLER_FINANCES")) {
      getStatementCharge(id);
    }
    if (viewSplit) {
      getSplitData();
    }
  }, [id, reload]);

  useEffect(() => {
    if (charge?.title === CHARGE_TITLE.VENDA_FISICA) {
      getRefundPOSData();
    }
  }, [charge]);

  const [isActiveCharge, setIsActiveCharge] = useState(false);
  const paymentMethod = charge.paymentMethod === PAYMENT_METHOD.BOLETO ? "boleto" : "pix";
  const paymentMethodMessage = charge.paymentMethod === PAYMENT_METHOD.BOLETO ? "Ver Boleto" : "Ver código PIX";

  function handleToggleDeleteChargeModal() {
    setDeleteChargeModalState(!deleteChargeModalState);
  }

  async function handleDeleteCharge() {
    try {
      await deleteCharge(id);
      showToast({ type: "success", message: "Sucesso na exclusão da cobrança." });
      setDeleteChargeModalState(!deleteChargeModalState);
      navigate(-1);
    } catch (error) {
      error?.response?.data?.errors.map((err) => {
        showToast({ type: "error", message: `${err?.code} - ${err?.description}` });
      });
    }
  }

  const chargebackModalContent = (props?: any) => (
    <Container>
      <section className="list-data">
        <p>
          Você recebeu uma contestação de cobrança feito pelo seguinte cliente:
        </p>
        <ul>
          <li>Nome do cliente: {charge?.customerName}</li>
          <li>Documento do cliente: {props?.customerDocument}</li>
          <li>Email do cliente: {props?.customerEmail}</li>
          <li>Telefone do cliente: {props?.customerPhone}</li>
        </ul>
      </section>
      <section className="list-data">
        <p>A contestação é relativa à venda:</p>
        <ul>
          <li>Título da cobrança: {props?.title}</li>
          <li>ID da cobrança: {props?.uuid}</li>
          <li>Valor: {props?.formattedValue}</li>
          <li>Data de pagamento: {props?.formattedPaidDate}</li>
        </ul>
      </section>
      <Divider />
      <section className="chargeback-documents">
        <p>
          Para contestar uma solicitação de estorno, deve ser enviado um email
          para <b>antifraude@barte.com</b> em até 5 dias corridos após a
          solicitação, dia{" "}
          {props?.chargebackDeadline
            ? format(new Date(props?.chargebackDeadline), "dd/MM/yyyy")
            : ""}
          , contendo os seguintes documentos:
        </p>
        <ol>
          <li>Relato do ocorrido, informando os documentos que serão apresentados na defesa da contestação;</li>
          <li>Cadastro do Portador (Nome do Titular do Cartão, Nome cadastrado no site, CPF, E mail, Endereço, telefone fixo, celular);</li>
          <li>Nota fiscal;</li>
          <li>Pedido da compra;</li>
          <li>Cópia da tela com os dados do meio de pagamento;</li>
          <li>Comprovação da prestação do serviço e/ou protocolo assinado pelo portador;</li>
          <li>Evidência de grau de parentesco entre o portador e o comprador;</li>
          <li>Carta do verdadeiro portador reconhecendo a despesa.</li>
        </ol>
        <p className="italic-text">
          *Não é obrigatório o envio de TODAS as documentações solicitadas,
          porém quanto mais documentações apresentadas, melhor será a defesa.
        </p>
        <Divider />
        <p className="final-content">
          Também enviamos essas informações para o seu email cadastrado na
          plataforma.
        </p>
        <p>Caso você não tenha recebido, entre em contato com o nosso atendimento.</p>
      </section>
    </Container>
  );

  async function handleGetCancelLetter(uuid: string) {
    let url: string;
    try {
      setIsLoadingCancelLetter(true);
      const response = await getCancelLetter(uuid);
      url = response.data.url;
      window.cancelLetterUrl = url;
      setTimeout(() => {
        if (window.cancelLetterUrl) {
          window.open(window.cancelLetterUrl, "_blank", "noopener,noreferrer");
          window.cancelLetterUrl = undefined;
        }
      }, 100);
    } catch (error) {
      showToast({ type: "error", message: "Erro ao gerar a carta de cancelamento." });
    } finally {
      setIsLoadingCancelLetter(false);
    }
  }

  async function handleSendCancelMail() {
    let url: string;
    try {
      setIsLoadingCancelMail(true);
      const response = await sendCancelMail(id);
      url = response.data.url;
      window.cancelMailUrl = url;
      setTimeout(() => {
        if (window.cancelMailUrl) {
          window.open(window.cancelMailUrl, "_blank", "noopener,noreferrer");
          window.cancelMailUrl = undefined;
        }
      }, 100);
    } catch (error) {
      showToast({ type: "error", message: "Erro ao gerar a carta de cancelamento." });
    } finally {
      setIsLoadingCancelMail(false);
    }
  }

  const elem = chargebackModalContent(charge);

  useEffect(() => {
    setIsActiveCharge(charge.formattedStatus === "Ativo" ? true : false);
  }, [charge]);

  function handleOpenErrorModal(uuid: string) {
    setErrorModalState(!errorModalState);
    setErrorModal(
      charge.chargesTries.filter((item) => item.uuid === uuid).at(0)
    );
  }

  const showGenerateReceipt = charge.status === CHARGE_STATUS.PAID && charge.title !== CHARGE_TITLE.VENDA_FISICA;

  const showChargeback =
    charge.status === CHARGE_STATUS.PAID &&
    (charge.paymentMethod === PAYMENT_METHOD.CREDIT_CARD || charge.paymentMethod === PAYMENT_METHOD.PIX) &&
    charge.title !== CHARGE_TITLE.VENDA_FISICA &&
    !featureTogglesUser?.includes(FEATURE_TOGGLE.VIEW_DISABLE_REFUND) &&
    !featureTogglesUser?.includes(FEATURE_TOGGLE.VIEW_SELLER_REFUND);

  const showDeleteCharge =
    charge.status === CHARGE_STATUS.SCHEDULED || charge.status === CHARGE_STATUS.LATE || charge.status === CHARGE_STATUS.FAILED;

  const isFullyRefunded = isChargeFullyRefunded(charge.status, responseVerify);

  const showRefund =
    (charge.status === CHARGE_STATUS.PAID || charge.status === CHARGE_STATUS.REFUND) &&
    !isFullyRefunded &&
    responseVerify?.[0]?.value > 0 &&
    (charge.paymentMethod === PAYMENT_METHOD.CREDIT_CARD || charge.paymentMethod === PAYMENT_METHOD.PIX) &&
    charge.title !== CHARGE_TITLE.VENDA_FISICA &&
    !featureTogglesUser?.includes(FEATURE_TOGGLE.VIEW_DISABLE_REFUND) &&
    featureTogglesUser?.includes(FEATURE_TOGGLE.VIEW_SELLER_REFUND);

  const showViewBoletoOrPix =
    showDeleteCharge &&
    (charge.paymentMethod === PAYMENT_METHOD.BOLETO || charge.paymentMethod === PAYMENT_METHOD.PIX);

  const chargesTriesColumns: ColumnDefinition<ChargesTries>[] = [
    {
      key: "date",
      title: "Data",
      dataIndex: "createdAt",
      render: (v, record) =>
        formatDate((v as string) ? (v as string) : record.expirationDate),
    },
    {
      key: "value",
      title: "Valor",
      dataIndex: "formattedValue" as keyof ChargesTries,
      render: (v) => v ?? "-",
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      render: (v, record) => {
        if (!v || v === CHARGE_STATUS.FAILED) {
          return v === CHARGE_STATUS.FAILED ? (
            <Button
              variant="link"
              iconRight={
                <Image
                  w="16px"
                  h="16px"
                  src="/images/icons/InfoOutlined.svg"
                />
              }
              onClick={() => handleOpenErrorModal(record.uuid)}
            >
              <Pills
                label="Pagamento falhou"
                variant="light"
                state={getColorBadgeStatus(CHARGE_STATUS.FAILED)}
              />
            </Button>
          ) : (
            "-"
          );
        }
        return (
          <Pills
            label={getStatus(v as string)}
            variant="light"
            state={getColorBadgeStatus(v as string)}
            size="sm"
          />
        );
      },
    },
  ];

  const refundHistoryColumns: ColumnDefinition<{
    amount: number;
    requestStatus: string;
    createdAt: string;
  }>[] = [
    {
      key: "createdAt",
      title: "Execução",
      dataIndex: "createdAt",
      render: (v) => formatDate(v as string),
    },
    { key: "activity", title: "Atividade", dataIndex: "requestStatus", render: () => "Estorno" },
    {
      key: "amount",
      title: "Valor",
      dataIndex: "amount",
      render: (v) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(v as number),
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "requestStatus",
      render: (v) =>
        v && v !== CHARGE_STATUS.FAILED ? (
          <Pills
            label={getStatus(v as string)}
            variant="light"
            state={getColorBadgeStatus(v as string)}
            size="sm"
          />
        ) : null,
    },
  ];

  const hasNFRole =
    user?.roles?.includes("SELLER_CONFIG_NF") ||
    user?.roles?.includes("SELLER_MASTER") ||
    user?.roles?.includes("SELLER_ADMIN") ||
    user?.roles?.includes("SELLER_BACKOFFICE");

  return (
    <>
      {charge && (
        <>
          <ErrorModal
            confirmButtonText="Concluir"
            status="Erro"
            clientName={charge?.customerName}
            modalState={errorModalState}
            setModalState={setErrorModalState}
            error={errorModal}
          />
          <Alert
            closeButtonText="Não"
            confirmButtonText="Sim"
            isConfirmAlert={false}
            isOpen={deleteChargeModalState}
            onConfirm={handleDeleteCharge}
            onClose={handleToggleDeleteChargeModal}
            title="Tem certeza que seja deletar essa cobrança?"
            messageBody="Essa ação não poderá ser desfeita"
            leastDestructiveRef={cancelRef}
          />
          <CustomModal
            isOpen={chargebackModalStateInfo}
            headerIcon={<InfoIconNotFilled color="#FFC53D" size={19} />}
            headerText="Dados da Contestação"
            confirmButtonText="Ok"
            modalBody={elem}
            onClose={() => setChargebackModalStateInfo(false)}
            onConfirm={() => setChargebackModalStateInfo(false)}
          />

          <Flex
            key={reload}
            direction="column"
            gap="8"
            position={`${chargebackModalStateInfo ? "fixed" : "relative"}`}
          >
            <PageHeading
              onBack={() => navigate("/cobrancas")}
              title="Detalhe da Cobrança"
              primaryActionLabel={
                showGenerateReceipt ? "Gerar comprovante"
                : showDeleteCharge ? "Excluir cobrança"
                : undefined
              }
              onPrimaryAction={
                showGenerateReceipt ? () => handleDownloadReceiptCharge(charge.uuid)
                : showDeleteCharge ? handleToggleDeleteChargeModal
                : undefined
              }
              secondaryActionLabel={
                showRefund ? "Estornar cobrança"
                : showViewBoletoOrPix ? paymentMethodMessage
                : undefined
              }
              onSecondaryAction={
                showRefund ? () => setIsRefundModalOpen(true)
                : showViewBoletoOrPix ? () => window.open(
                    `${getTenantConfig().checkoutUrlV2}${paymentMethod}/${id}`,
                    "_blank"
                  )
                : undefined
              }
            />
            <Card
              actions={
                charge.status === CHARGE_STATUS.DISPUTE ? (
                  <Button
                    variant="outline"
                    onClick={() => setChargebackModalStateInfo(true)}
                  >
                    Saiba mais
                  </Button>
                ) : undefined
              }
            >
              <Flex justify="space-between" align="center" w="100%">
                <Flex direction="column" gap="2">
                  <Flex align="center">
                    {charge?.customerId ? (
                      <Tooltip label="Clique para ver detalhes do cliente">
                        <Link
                          to={`/clientes/${charge?.customerId}`}
                          style={{ fontWeight: 600, fontSize: "20px", color: "#0a0a0a" }}
                          target="_blank"
                        >
                          {charge.customerName}
                        </Link>
                      </Tooltip>
                    ) : (
                      <Text fontWeight="600" fontSize="20px" color="#0a0a0a">
                        {charge.customerName}
                      </Text>
                    )}
                  </Flex>
                  <Flex gap="2">
                    {charge.customerPhone && (
                      <Pills
                        label={phone_format(charge.customerPhone)}
                        icon={WhatsappLogoIcon}
                        size="base"
                      />
                    )}
                    {charge.customerEmail && (
                      <Pills
                        label={charge.customerEmail}
                        icon={EnvelopeIcon}
                        size="base"
                      />
                    )}
                  </Flex>
                </Flex>

                <Flex direction="column" align="flex-end" gap="2">
                  <Text fontWeight="600" fontSize="20px" color="#0a0a0a">
                    {charge.formattedValue}
                  </Text>
                  <Flex align="center" gap="3">
                    <ChangeToPaid
                      status={charge.status}
                      setShowAlert={setShowAlert}
                    />
                    <Pills
                      label={getStatus(charge.status)}
                      variant="light"
                      state={getColorBadgeStatus(charge.status)}
                      size="base"
                    />
                  </Flex>
                </Flex>
              </Flex>
            </Card>
            {showChargeback && (
              <Chargeback
                handleToggleChargebackModal={() => setChargebackModalState(true)}
                amount={charge.value}
                chargeUuid={charge.uuid}
              />
            )}
            {showRefund && (
                <RefundModal
                  responseVerify={responseVerify}
                  isDisabled={loading}
                  charge={charge}
                  setReload={setReload}
                  isOpen={isRefundModalOpen}
                  onClose={() => setIsRefundModalOpen(false)}
                  onRefundSuccess={async (chargeId: string) => {
                    await verifyRefundBalance(chargeId);
                  }}
                />
              )}
            {charge.status === CHARGE_STATUS.PAID &&
              charge.paymentMethod === PAYMENT_METHOD.CREDIT_CARD &&
              charge.title === CHARGE_TITLE.VENDA_FISICA &&
              !featureTogglesUser?.includes(FEATURE_TOGGLE.VIEW_DISABLE_REFUND) &&
              featureTogglesUser?.includes(FEATURE_TOGGLE.VIEW_SELLER_REFUND_POS) && (
                <Flex justify="flex-end">
                  <RefundPOSModal
                    isDisabled={loading}
                    charge={charge}
                    setReload={setReload}
                    isProcessingRefund={
                      refundData?.attempts?.length > 0 &&
                      refundData?.attempts[0]?.status === "PROCESSING"
                    }
                  />
                </Flex>
              )}
            <Section
              title="Informações gerais"
              variant="two-columns"
              secondColumn={
                <>
                  <ContentRow
                    label="Vencimento"
                    content={formatDate(charge.expirationDate)}
                  />
                  <ContentRow label="Código da cobrança" content={charge.uuid} />
                  {(charge.status === CHARGE_STATUS.REFUND || (charge.status === CHARGE_STATUS.PAID && responseVerify?.[0]?.refunds?.length > 0)) && (
                    <ContentRow
                      label="Carta de estorno"
                      content={
                        <Button
                          id="carta_cancelamento"
                          variant="link"
                          iconRight={
                            <Image
                              w="16px"
                              h="16px"
                              src="/images/icons/DownloadOutlined.svg"
                            />
                          }
                          onClick={handleSendCancelMail}
                          loading={isLoadingCancelMail}
                          disabled={isLoadingCancelMail}
                        >
                          Abrir carta de estorno
                        </Button>
                      }
                    />
                  )}
                  {charge.status === CHARGE_STATUS.CANCELED && (
                    <ContentRow
                      label="Carta de cancelamento"
                      content={
                        <Button
                          id="carta_cancelamento"
                          variant="link"
                          iconRight={
                            <Image
                              w="16px"
                              h="16px"
                              src="/images/icons/DownloadOutlined.svg"
                            />
                          }
                          onClick={() => handleGetCancelLetter(charge.uuid)}
                          loading={isLoadingCancelLetter}
                          disabled={isLoadingCancelLetter}
                        >
                          Abrir carta de cancelamento
                        </Button>
                      }
                    />
                  )}
                  {responseVerify?.[0]?.refunds?.[0]?.requestStatus === "processing" && (
                    <ContentRow
                      label="Status do último Estorno"
                      content={
                        <Flex gap="10px" alignItems="center">
                          <Pills
                            label={getStatus(responseVerify?.[0]?.refunds?.[0]?.requestStatus)}
                            variant="light"
                            state={getColorBadgeStatus(responseVerify?.[0]?.refunds?.[0]?.requestStatus)}
                            size="base"
                          />
                          <Button
                            variant="link"
                            iconLeft={<FiDownload />}
                            onClick={() =>
                              handleSolicitationRefundLetter(charge.uuid)
                            }
                            loading={isGenerating}
                          >
                            Baixar comprovante
                          </Button>
                        </Flex>
                      }
                    />
                  )}
                </>
              }
            >
              <ContentRow
                label="Produto/Serviço"
                content={charge.title || "-"}
              />
              <ContentRow
                label="Método de Pagamento"
                content={
                  <Flex align="center" gap="2px">
                    <Text fontSize="14px">
                      {charge.paymentMethod === "CREDIT_CARD_EARLY_MIXED"
                        ? PAYMENT_METHOD.CREDIT_CARD
                        : charge.paymentMethod}
                    </Text>
                    {(charge?.tradeAgreement?.type === "DEFAULT" ||
                      charge?.tradeAgreement === null) &&
                      charge.paymentMethod !== "CREDIT_CARD_EARLY_MIXED" && (
                        <ChargeInstallments
                          installments={charge?.installments}
                        />
                      )}
                  </Flex>
                }
              />
              <ContentRow
                label="Data do pagamento"
                content={charge?.formattedPaidDate ?? "-"}
              />
              {charge.paymentMethod === PAYMENT_METHOD.BOLETO && (
                <ContentRow
                  label="Juros e Multa"
                  content={charge?.formattedInterestAmount ?? "-"}
                />
              )}
            </Section>

            {charge.threeDSSecure && (
              <Section
                title="Transação validada via 3DS"
                variant="two-columns"
                secondColumn={
                  <ContentRow
                    label="Transferência de Responsabilidade"
                    content={
                      charge.threeDSSecure.liabilityShift ? "Sim" : "Não"
                    }
                  />
                }
              >
                <ContentRow
                  label="Tipo"
                  content={
                    charge.threeDSSecure.challenged
                      ? "Challenge"
                      : "Frictionless"
                  }
                />
              </Section>
            )}
            {charge?.cardResponse &&
              Object.keys(charge?.cardResponse)?.length > 0 && (
                <Section
                  title="Informações de pagamento"
                  variant="two-columns"
                  secondColumn={
                    <ContentRow
                      label="Titular do cartão"
                      content={charge?.cardResponse?.cardHolderName}
                    />
                  }
                >
                  <ContentRow
                    label="Cartão de crédito"
                    content={charge?.cardResponse?.last4digits}
                  />
                  <ContentRow
                    label="Bandeira"
                    content={charge?.cardResponse?.brand}
                  />
                </Section>
              )}

            {hasNFRole && <InvoiceTable />}

            {charge?.paymentReceiptType &&
              user?.roles?.includes("SELLER_FINANCES") && (
                <ReceivableTable statementCharge={statementCharge?.data} />
              )}

            {viewSplit && <SplitTable splitData={splitData} />}

            {charge.chargesTries &&
              charge?.paymentMethod === PAYMENT_METHOD.CREDIT_CARD && (
                <Flex direction="column" gap="4">
                  <Text fontWeight="bold" fontSize="16px" color="#0f172a">
                    Histórico de Tentativas
                  </Text>
                  <Table
                    data={charge.chargesTries}
                    columns={chargesTriesColumns}
                    rowKey={(r) => r.uuid}
                  />
                </Flex>
              )}

            {charge?.chargesTries &&
              charge?.paymentMethod === PAYMENT_METHOD.CREDIT_CARD &&
              responseVerify?.[0]?.refunds &&
              responseVerify[0].refunds.length > 0 && (
                <Flex direction="column" gap="4" pb="40px">
                  <Text fontWeight="bold" fontSize="16px" color="#0f172a">
                    Histórico de atividades
                  </Text>
                  <Table
                    data={responseVerify[0].refunds}
                    columns={refundHistoryColumns}
                    rowKey={(r) => `${r.createdAt}-${r.amount}`}
                  />
                </Flex>
              )}
          </Flex>

          <Alert
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            onConfirm={() => handleChangeToPaid(id, onClose)}
            isOpen={showAlert}
            hideIcon
            title={changeToPaidAlertTitle}
            messageBody={<ChangeToPaidAlertMessage status={charge.status} />}
            closeButtonText="Cancelar"
            confirmButtonText="Confirmar"
          />
          <Alert
            leastDestructiveRef={cancelRef}
            onClose={() => setChargebackModalState(false)}
            onConfirm={() =>
              handleChargeBackCharge(
                id,
                setChargebackModalState,
                fraudCheckboxState
              )
            }
            isOpen={chargebackModalState}
            checkBox
            checkBoxValue={fraudCheckboxState}
            checkBoxFunction={setFraudCheckboxState}
            checkBoxText="Possível fraude"
            closeButtonText="Cancelar"
            title="Deseja estornar essa cobrança?"
            messageBody="Essa ação não poderá ser desfeita."
          />
        </>
      )}
    </>
  );
}

export default WithAuth(CobrancaDetalhes);
